export default __webpack_public_path__ + "static/media/IMG_1530.171ff194.jpg";